module.exports = __webpack_public_path__ + "assets/img/banner6.6ef6d16c.png";